import { render, staticRenderFns } from "./CardOrder.vue?vue&type=template&id=7147812e&scoped=true"
import script from "./CardOrder.vue?vue&type=script&lang=js"
export * from "./CardOrder.vue?vue&type=script&lang=js"
import style0 from "./CardOrder.vue?vue&type=style&index=0&id=7147812e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7147812e",
  null
  
)

export default component.exports